module.exports = __webpack_public_path__ + "img/136.1.56934b95.jpg";